<template>
<div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card  border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-6 d-none d-lg-block bg-login-image"></div>
              <div class="col-lg-6">
                <div class="p-5">
                  <div class="text-center">
                    <router-link to="/">
                      <img class="img-responsive" id="logo" src="../../public/images/smile_logo.png">
                    </router-link>
                    <h1 class="h5 text-gray-900 mb-4">{{ $t('Insert_new_password') }}</h1>
                    <div v-if="error.message" class="alert alert-danger" role="alert">
                      {{ error.message }}
                    </div>
                    <div v-if="success" class="alert alert-success" role="alert">
                      {{ $t('Password_changed_successfully') }}
                    </div>
                  </div>
                  <form class="user" v-on:submit="reset">
                    <div class="form-group">
                      <input type="password" v-model="password" class="form-control form-control-user" aria-describedby="emailHelp" :placeholder="$t('Password')">
                    </div>
                    <div class="form-group">
                      <input type="password" v-model="password_confirmation" class="form-control form-control-user" aria-describedby="emailHelp" :placeholder="$t('Password')">
                    </div>
                    <input type="submit" :value="$t('Change_password')" class="btn btn-primary btn-user btn-block">
                  </form>
                  <hr>
                  <div class="text-center mt-2">
                    <SelectLanguage></SelectLanguage>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectLanguage from './SelectLanguage.vue'
export default  {
  name: 'reset-password',
  components: {
    SelectLanguage,
  },
  data() {
    return {
      password: "",
      password_confirmation: "",
      success: null,
      error: {
        code: null,
        message: null
      }
    }
  },
  methods: {
    reset: function(){
      if (this.password=="" || this.password_confirmation=="") return
      this.$store.dispatch('resetPassword', { password: this.password, password_confirmation: this.password_confirmation, token:this.token }).then(() => {
        this.success = true
        setTimeout(() => {
          this.$router.push('/')
        }, 3000)
      }).catch(e => {
        this.error.code = e.response.data.error
        this.error.message = this.$i18n.t(e.response.data.error)
      })
    }
  },
  computed: {
    token: function(){
      return this.$route.params.token
    },
    current_lang: function(){
      return this.$i18n.locale
    }
  },
  watch: {
    current_lang: function(){
      if (this.error.code) this.error.message = this.$i18n.t(this.error.code)
    }
  }
}
</script>

<style scoped>
.bg-login-image {
  background: url("../../public/images/insert_password.png");
  background-position: center;
  background-size: cover;
}

#logo{
  max-height: 130px;
}
</style>
